import { useLayoutEffect, useRef } from 'react';

const useAutoScroll = ({
  activeIndex,
  keyboardControlled,
  listRef,
  optionsRef,
  selectedIndex,
}: {
  optionsRef: React.RefObject<HTMLDivElement>;
  listRef: React.MutableRefObject<HTMLElement[]>;
  activeIndex: number | null;
  selectedIndex: number | null;
  keyboardControlled: boolean;
}) => {
  const prevActiveIndexRef = useRef<number | null>();
  useLayoutEffect(() => {
    prevActiveIndexRef.current = activeIndex;
  }, [activeIndex]);
  const prevActiveIndex = prevActiveIndexRef.current;

  useLayoutEffect(() => {
    const options = optionsRef.current;

    if (options && keyboardControlled) {
      let activeItem = null;
      if (activeIndex != null) {
        activeItem = listRef.current[activeIndex];
      } else if (selectedIndex != null) {
        activeItem = listRef.current[selectedIndex];
      }
      if (activeItem && prevActiveIndex != null) {
        const activeItemHeight = listRef.current[prevActiveIndex]?.offsetHeight ?? 0;

        const floatingHeight = options.offsetHeight;
        const top = activeItem.offsetTop;
        const bottom = top + activeItemHeight;

        if (top < options.scrollTop) {
          options.scrollTop -= options.scrollTop - top + 5;
        } else if (bottom > floatingHeight + options.scrollTop) {
          options.scrollTop += bottom - floatingHeight - options.scrollTop + 5;
        }
      }
    }
  }, [prevActiveIndex, activeIndex, optionsRef, selectedIndex, keyboardControlled]);

  useLayoutEffect(() => {
    requestAnimationFrame(() => {
      const options = optionsRef.current;
      if (options && options.clientHeight < options.scrollHeight) {
        const selectedItem = selectedIndex && listRef.current[selectedIndex];
        if (selectedItem) {
          options.scrollTop = selectedItem.offsetTop - options.offsetHeight / 2 + selectedItem.offsetHeight / 2;
        }
      }
    });
  }, [selectedIndex, optionsRef]);
};

export default useAutoScroll;
